import React, {useState, useEffect} from 'react';
import styled from "styled-components";
import {Switch} from "react-materialize";

import {StyledForeground} from "../Components/Commons/StyledForeground.react";
import TBSearch from "../Components/Commons/Search.react";
import FiltersModal from "../Components/Commons/FiltersModal.react";
import HoldingsCharts from "../Components/Holdings/HoldingsCharts.react";

const StyledHoldingsPage = styled.div`
  padding: 3rem 2rem 8rem 2rem;
  min-height: 100vh;
  
  h1 {
    color: white;
  }
  
  .header {
    display: flex;
    justify-content: space-between;
  }
  
  .subheader {
    color: white;
    display: flex;
    justify-content: space-between;
    margin-bottom: 2rem;
    margin-top: 3rem;
    
    label {
      font-size: 2rem;
      color: white;
    }
  }
  
  .content {
    height: 100%;
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }

`

const HoldingsPage = () => {
  const [loading, setLoading] = useState(true);
  const [showBySource, setShowSource] = useState(false)

  useEffect(() => {
    setLoading(false);
  }, [])

  const handleSearch = () => {
    alert('Searching')
  }

  const handleSwitch = () => {
    setShowSource(!showBySource);
  }

  return (
    <StyledHoldingsPage>
      <StyledForeground/>
      <div className={'header'}>
        <h1>Holdings</h1>
        <TBSearch darkMode placeHolder={'Search'} handleSearch={handleSearch} />
      </div>
      <div className={'subheader'}>
        <div className={'filters'}>
          <FiltersModal />
        </div>
        <Switch
          id={'source-toggler'}
          offLabel={'Consolidated'}
          onLabel={'By Source'}
          onChange={handleSwitch}
          checked={showBySource}
        />
      </div>
      <HoldingsCharts showBySource={showBySource} />
    </StyledHoldingsPage>
  )
}

export default HoldingsPage;
